import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NotFound = () => {
    return (
        <main
            data-testid="page-not-found"
            className="bg-white text-[#111111] min-h-screen flex items-center"
        >
            <SEO
                title="Siden findes ikke (404) | MM Byggeri & Rådgivning"
                description="Siden du søgte, blev ikke fundet. Gå tilbage til forsiden eller se vores udvalgte cases."
                path="/404"
                noindex
            />

            <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-40 w-full">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-8">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888] mb-6">
                            404
                        </div>
                        <h1 className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
                            Siden findes ikke.
                        </h1>
                        <p className="mt-10 max-w-xl text-base md:text-lg font-light text-[#555] leading-[1.75] tracking-[0.01em]">
                            Vi kunne ikke finde den side, du leder efter. Vend
                            tilbage til forsiden eller se vores udvalgte cases.
                        </p>
                        <div className="mt-12 flex flex-wrap gap-6">
                            <Link
                                to="/"
                                data-testid="notfound-home-link"
                                className="text-[11px] tracking-luxury uppercase link-underline"
                            >
                                Til forsiden
                            </Link>
                            <Link
                                to="/cases"
                                data-testid="notfound-cases-link"
                                className="text-[11px] tracking-luxury uppercase link-underline"
                            >
                                Se cases
                            </Link>
                            <Link
                                to="/kontakt"
                                data-testid="notfound-contact-link"
                                className="text-[11px] tracking-luxury uppercase link-underline"
                            >
                                Kontakt
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NotFound;
